import { Helmet } from "react-helmet-async";

// Per-route SEO. Absolute URLs are built from the live origin at render time,
// so they are correct on whatever domain the app is deployed to.
export const Seo = ({ title, description, path = "/", image, type = "website", children }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const imageUrl = image ? (image.startsWith("http") ? image : `${origin}${image}`) : null;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      <meta name="twitter:card" content={imageUrl ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      {children}
    </Helmet>
  );
};
